export const phoneValidation = /\(\d{3}\) \d{3}-\d{4}/;
